<template>
  <el-dialog
    :title="editingData ? '编辑求职期望' : '添加求职期望'"
    :visible.sync="innerVisible"
    width="900px"
    :append-to-body="true"
    custom-class="job-expectation-dialog"
    @close="handleClose"
  >
    <el-form :model="form" label-width="120px" ref="formRef">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="求职类型" prop="job_type">
            <el-select v-model="form.job_type" placeholder="请选择">
              <el-option 
                v-for="jobType in jobTypes" 
                :key="jobType.value" 
                :label="jobType.label" 
                :value="jobType.value" 
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期望职位" prop="job_objective">
            <el-input v-model="form.job_objective" placeholder="请输入期望职位" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作地点" prop="desired_city">
            <el-select
              v-model="form.desired_city"
              multiple
              filterable
              collapse-tags
              clearable
              placeholder="搜索心动城市"
              class="el-select-flex city-select"
              popper-class="city-dropdown"
            >
              <el-option label="全国" value="全国" />
              <el-option-group label="热门城市">
                <el-option v-for="c in hotCities" :key="c" :label="c" :value="c" />
              </el-option-group>
              <el-option-group v-for="(list, letter) in citiesByLetter" :key="letter" :label="letter">
                <el-option v-for="c in list" :key="c" :label="c" :value="c" />
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期望薪资" prop="expected_salary">
            <div class="row-compact">
              <el-input 
                v-model="form.expected_salary_start" 
                type="text" 
                :placeholder="isIntern ? '最低薪资(元/天)' : '最低薪资(K/月)'"
              />
              <span class="dash">—</span>
              <el-input 
                v-model="form.expected_salary_end" 
                type="text"  
                :placeholder="isIntern ? '最高薪资(元/天)' : '最高薪资(K/月)'"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { JOB_TYPES } from '@/constants/jobConstants'
import { HOT_CITIES, CITIES_BY_LETTER } from '@/constants/cityConstants'
import { addUserExpect, editUserExpect } from '@/api/user'

export default {
  name: 'JobExpectationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editingData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      innerVisible: this.visible,
      jobTypes: JOB_TYPES.map(item => ({
        label: item.label,
        value: item.value
      })),
      hotCities: HOT_CITIES,
      citiesByLetter: CITIES_BY_LETTER,
      form: {
        id: '',
        job_type: '',
        job_objective: '',
        desired_city: [],
        expected_salary_start: '',
        expected_salary_end: ''
      }
    }
  },
  computed: {
    isIntern() {
      return this.form && (this.form.job_type === '2' || this.form.job_type === 2)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initForm()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
        this.$emit('close')
        this.resetForm()
      }
    },
    editingData: {
      handler(newVal) {
        if (newVal && this.innerVisible) {
          this.initForm()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initForm() {
      if (this.editingData) {
        this.form = {
          id: this.editingData.id || '',
          job_type: this.editingData.job_type || '',
          job_objective: this.editingData.job_objective || '',
          desired_city: Array.isArray(this.editingData.desired_city) 
            ? this.editingData.desired_city 
            : (this.editingData.desired_city ? this.editingData.desired_city.split(',') : []),
          expected_salary_start: this.editingData.expected_salary_start || '',
          expected_salary_end: this.editingData.expected_salary_end || ''
        }
      } else {
        this.resetForm()
      }
    },
    resetForm() {
      this.form = {
        id: '',
        job_type: '',
        job_objective: '',
        desired_city: [],
        expected_salary_start: '',
        expected_salary_end: ''
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    },
    handleClose() {
      this.innerVisible = false
    },
    async handleSubmit() {
      const submitData = {
        ...this.form,
        desired_city: Array.isArray(this.form.desired_city)
          ? this.form.desired_city.join(',')
          : (this.form.desired_city || '')
      }

      // 实习：仅提交 expected_salary_start，expected_salary_end 置空
      if (this.isIntern) {
        submitData.expected_salary_start = `${submitData.expected_salary_start}元 - ${submitData.expected_salary_end}元/天` || ''
        submitData.expected_salary_end = ''
      }

      if (this.form.id) submitData.id = this.form.id

      try {
        let res
        if (submitData.id) {
          res = await editUserExpect(submitData)
        } else {
          res = await addUserExpect(submitData)
        }
        if (res && res.data && res.data.code === 1) {
          this.$message && this.$message.success(submitData.id ? '更新成功' : '添加成功')
          // 通知父级已保存
          this.$emit('submitted', { payload: submitData, response: res })
          // 兼容旧用法
          this.$emit('submit', { payload: submitData, response: res })
          this.innerVisible = false
        } else {
          this.$message && this.$message.error(res?.data?.msg || '操作失败')
        }
      } catch (e) {
        this.$message && this.$message.error('提交失败，请重试')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%
}

.row-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .el-input {
    width: 136px;
  }
  .unit {
    color: #909399;
    font-size: 12px;
  }
}

.dash {
  color: #606266;
  font-weight: 500;
}
</style>
